module.exports = ".list-item-container{display:flex;width:100%;height:auto;border-radius:8px;margin:5px;padding:15px}.text-justify{text-align:justify}\n"